
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        color: {
            type: Number as PropType<number>,
            default: () => 0
        }
    }
})
